import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import {
  Authorisation,
  GetUserAuthorisationQueryParams,
  GetUsersEmailsQueryParams,
  GetUsersQueryParams,
  PaginatedUsers,
  PatchUserSettingsRequestBody,
  User,
  UserSettings
} from "src/types";
import { UserProfile } from "src/types/api/users/accounts/userProfile";

class UserAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/user");
  }

  async getUserAuthorisation(queryParams?: GetUserAuthorisationQueryParams): Promise<Authorisation> {
    const path = `/authorisation`;

    return await this.jwtRequest("GET", path, undefined, queryParams);
  }

  async getUserVendorsActivePOs(): Promise<string[]> {
    const path = `/vendors/active-purchase-orders`;

    return await this.jwtRequest("GET", path);
  }

  async getUserSettings(): Promise<{ userName: string; userSettings: UserSettings }> {
    const path = `/settings`;

    return await this.jwtRequest("GET", path);
  }

  async getUserProfile(): Promise<UserProfile> {
    const path = `/profile`;

    return await this.jwtRequest("GET", path);
  }

  async getUsersEmails(queryParams: GetUsersEmailsQueryParams): Promise<string[]> {
    const path = `/emails`;

    return await this.jwtRequest("GET", path, undefined, queryParams, "/v1/users");
  }

  async getUsers(queryParams: GetUsersQueryParams): Promise<PaginatedUsers> {
    return await this.jwtRequest("GET", "", undefined, queryParams, "/v1/users");
  }

  async patchUserSettings(requestBody: PatchUserSettingsRequestBody): Promise<User> {
    const path = `/settings`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }
}

export { UserAPIService };
